module.exports = __webpack_public_path__ + "img/P150T_weapon_72.d58b3e8d.png";